import { preventMinification } from '@/@core/utils/preventMinification';
import { useUserStore } from '@/stores/userStore';
import {
  AnalyticsVuePlugin,
  FaroAnalyticsPlugin,
  analytics,
  anonymizeUserId,
} from '@aleph-alpha/lib-analytics';
import postHog from '@metro-fs/analytics-plugin-posthog';
import { watch, ref, type App } from 'vue';

export async function setupAnalytics(app: App, faroApiKey: string) {
  const user = useUserStore();
  const lastIdentified = ref<string | null>(null);
  app.use(AnalyticsVuePlugin, {
    plugins: [
      postHog({
        token: import.meta.env.VITE_POSTHOG_TOKEN,
        enabled: preventMinification(import.meta.env.VITE_POSTHOG_TOKEN) !== '',
        options: {
          api_host: import.meta.env.VITE_POSTHOG_API_HOST,
          ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
          session_recording: {
            // Mask all inputs by default for maximum privacy
            maskAllInputs: true,
            // Mask all text content by default
            maskTextSelector: '*',
          },
        },
      }),
      FaroAnalyticsPlugin({
        enabled:
          preventMinification(import.meta.env.VITE_FARO_TELEMETRY_URL) !== '',
        url: preventMinification(import.meta.env.VITE_FARO_TELEMETRY_URL),
        apiKey: faroApiKey,
      }),
    ],
    app: import.meta.env.INSTRUMENTATION_APP_IDENTIFIER || 'assistant',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    debug: false,
  });
  watch(
    () => user.userId,
    async (userId: string | null) => {
      if (userId && userId !== lastIdentified.value) {
        const anonId = await anonymizeUserId(
          userId,
          import.meta.env.VITE_ANONYMIZATION_SALT,
        );
        analytics.identify(anonId);
        lastIdentified.value = userId;
      }
    },
    { immediate: true },
  );
}
